export default __webpack_public_path__ + "static/media/touxiang.915abb47.png";